export const MAX_AGE_RESTRICTION = 99;
export const MIN_AGE_RESTRICTION = 1;
export const RESTRICTED_AGE = 13;

export const VIDEO_RESPONSE_CONSENT = 'video_response';
export const VIEWER_NDA_CONSENT = 'viewer_consent';
export const ACCEPT_TERMS_N_CONDITIONS = 'y';


// WEBPACK FOOTER //
// ./src/constants/registrationConstants.js